/************
 * Developed by : Shiva Software Solutions
 * Date : 08-08-2025
 * Descriptions : Route for Discharge Summary
 ************/
import React from 'react';
import {authRole} from '../../shared/constants/AppConst';
//Route config for eRx details
export const dissummaryprocessConfigs = [
  {
    auth: authRole.user,
    routes: [
      {
        path: '/dischargesummaryProcess',
        component: React.lazy(() => import('./ProcessingPage')),
      },
    ],
  },
];
